<template>
    <div class="mobile-header">
        <Arrow class="mobile-header-arrow"
               :direction="DirectionsEnum.LEFT"
               @click="emit('clicked')" />
        <div>
            {{ title }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { DirectionsEnum } from '@/js/enums/directions';
    import Arrow from '../../../components/icons/Arrow.vue';

    defineProps<{
        title: string,
    }>();

    const emit = defineEmits<{(e: 'clicked'): void; }>();
</script>

<style scoped lang="scss">
.mobile-header {
    display: flex;
    align-items: center;
    margin: 8px 6px 6px;
    font-size: 20px;
    font-weight: 700;
    line-height: 22px;

    .mobile-header-arrow {
        margin-right: 16px;
        margin-bottom: 4px;
    }
}
</style>
